import React from 'react';
import { FadeIn } from './FadeIn';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-cream" data-id="element-43">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-44">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-45">
          <div className="max-w-2xl" data-id="element-46">
            <FadeIn data-id="element-47">
              <div className="flex flex-wrap items-center gap-3 mb-6" data-id="element-48">
                <span className="inline-block py-1 px-3 rounded-full bg-terracotta/10 text-terracotta text-sm font-medium tracking-wide" data-id="element-49">
                  Para madres de niños de 0 a 5 años
                </span>
                <span className="inline-block py-1 px-3 rounded-full bg-terracotta text-white text-sm font-bold tracking-wide animate-pulse" data-id="element-50">
                  🎉 -68% Mes de las Madres
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-51">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brown leading-tight mb-6" data-id="element-52">
                Sintonía Total: <br data-id="element-53" />
                <span className="text-terracotta italic font-normal" data-id="element-54">
                  El Manual de Conexión
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-55">
              <p className="text-lg md:text-xl text-brown-light mb-8 leading-relaxed" data-id="element-56">
                Deja de sobrevivir a la crianza y empieza a entender el porqué
                de cada cambio, rabieta y crisis de tu hijo para crecer juntos
                en paz.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-57">
              <button onClick={scrollToPricing} className="w-full sm:w-auto px-8 py-4 bg-terracotta hover:bg-terracotta-dark text-white rounded-full font-medium text-lg transition-colors duration-300 shadow-lg shadow-terracotta/20 inline-flex items-center gap-3" data-id="element-58">
                Quiero el Manual Ahora
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-59">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" data-id="element-60" />
                </svg>
              </button>
            </FadeIn>
          </div>

          <div className="relative lg:ml-auto" data-id="element-61">
            <FadeIn delay={0.4} direction="left" data-id="element-62">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-brown/10 border border-brown/5" data-id="element-63">
                <img src="https://cdn.magicpatterns.com/uploads/1JWH9FxYhMZbg9BnBJhFty/heylloyd-image-1777555284542.png" alt="Sintonía Total Manual en Tablet" className="w-full h-auto object-cover" data-id="element-64" />
              </div>
              {/* Decorative elements */}
              <div className="absolute -z-10 top-1/2 -translate-y-1/2 -right-12 w-64 h-64 bg-terracotta/5 rounded-full blur-3xl" data-id="element-65"></div>
              <div className="absolute -z-10 -bottom-12 -left-12 w-48 h-48 bg-sage/10 rounded-full blur-2xl" data-id="element-66"></div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}